module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.label) + " Lembrete")])]), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Item"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "placeholder": "Nome do Item",
      "maxlength": "300"
    },
    model: {
      value: (_vm.reminder.name),
      callback: function($$v) {
        _vm.$set(_vm.reminder, "name", $$v)
      },
      expression: "reminder.name"
    }
  })], 1), _c('b-field', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Selecionar...",
      "expanded": "expanded"
    },
    model: {
      value: (_vm.reminder.type),
      callback: function($$v) {
        _vm.$set(_vm.reminder, "type", $$v)
      },
      expression: "reminder.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "Recorrente"
    }
  }, [_vm._v("Recorrente")]), _c('option', {
    attrs: {
      "value": "Pontual"
    }
  }, [_vm._v("Pontual")])])], 1), _c('b-field', {
    attrs: {
      "label": "Valor Médio"
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validations.value),
      expression: "validations.value"
    }, {
      name: "money",
      rawName: "v-money",
      value: ({}),
      expression: "{}"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Valor Médio",
      "name": "value",
      "data-vv-as": "valor"
    },
    model: {
      value: (_vm.reminder.value),
      callback: function($$v) {
        _vm.$set(_vm.reminder, "value", $$v)
      },
      expression: "reminder.value"
    }
  })], 1), _c('b-field', {
    attrs: {
      "label": "Dia*",
      "message": _vm.errors.first('day'),
      "type": _vm.isDanger('day')
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Selecionar...",
      "expanded": "expanded"
    },
    model: {
      value: (_vm.reminder.day),
      callback: function($$v) {
        _vm.$set(_vm.reminder, "day", $$v)
      },
      expression: "reminder.day"
    }
  }, _vm._l((31), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v("Dia " + _vm._s(n))])
  }), 0)], 1)], 1), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Salvar")]), _c('a', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.close()
      }
    }
  }, [_vm._v("Cancelar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dddf2c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/components/ReminderModal.vue
// module id = 406
// module chunks = 56